module.exports = __webpack_public_path__ + "fonts/Athene-2.08325c54.otf";